import React from "react";
import Modal from "components/Modal";
import genericModalStyles from "helpers/genericModalStyles";
import PropTypes from "prop-types";
import "./_style.scss";
import LinkButton from "components/LinkButton";

const ModalDeleteConfirmation = ({
  onCancel, onDelete, isOpen, message, modelName, modalTitle, deleteLabel, cancelLabel, isDeleting = false,
}) => {
  const getDeleteMessage = () => {
    if (message) {
      return message;
    }

    if (modelName) {
      return `Are you sure you want to delete this ${modelName.toLowerCase()}?`;
    }

    return "Are you sure you want to delete this?";
  };

  const getTitle = () => {
    if (modalTitle) {
      return modalTitle;
    }

    if (modelName) {
      return `Delete ${modelName}`;
    }

    return "Delete Confirmation";
  };

  return (
    <Modal
      contentLabel={`Delete ${modelName}`}
      customStyle={genericModalStyles}
      isOpen={isOpen}
      ariaHideApp={false}
      shouldCloseOnOverlayClick
      onRequestClose={onCancel}
      className="confirm-deletion-modal"
    >
      <div>
        <div className="confirm-deletion-modal__header">
          <div className="confirm-deletion-modal__heading">
            {getTitle()}
          </div>
        </div>

        <p
          className="confirm-deletion-modal__subtext"
          dangerouslySetInnerHTML={{
            __html: getDeleteMessage(),
          }}
        />

        <div className="confirm-deletion-modal__actions">
          <LinkButton
            onClick={onDelete}
            size="small"
            isBold
            look="primary"
            data-testid={`delete-${modelName?.toLowerCase()}-button`}
            isLoading={isDeleting}
          >
            {deleteLabel ?? "Delete"}
          </LinkButton>

          <LinkButton
            onClick={onCancel}
            size="small"
            isBold
            look="secondary-outline"
            data-testid={`cancel-delete-${modelName?.toLowerCase()}-button`}
            isLoading={isDeleting}
          >
            {cancelLabel ?? "Cancel"}
          </LinkButton>
        </div>
      </div>
    </Modal>
  );
};

ModalDeleteConfirmation.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  modelName: PropTypes.string,
  message: PropTypes.string,
  modalTitle: PropTypes.string,
  deleteLabel: PropTypes.string,
  cancelLabel: PropTypes.string,

};

export default ModalDeleteConfirmation;
